var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
import { Track } from 'livekit-client';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { RecordingEvent, RecordingType, } from './IRecording';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../../../../helpers/proto/plugnmeet_datamessage_pb';
import { store } from '../../../../store';
import { sendWebsocketMessage } from '../../../../helpers/websocket';
const useLocalRecording = (localParticipant, roomId) => {
    _react_refresh_temp_1();
    const [recordingEvent, setRecordingEvent] = useState(RecordingEvent.NONE);
    const [hasError, setHasError] = useState(false);
    const [captureStream, setCaptureStream] = useState(null);
    const [recorder, setRecorder] = useState(null);
    const TYPE_OF_RECORDING = RecordingType.RECORDING_TYPE_LOCAL;
    let recordingData = [];
    const displayMediaOptions = {
        preferCurrentTab: true,
        video: true,
        audio: true,
    };
    const session = store.getState().session;
    const { t } = useTranslation();
    const startRecording = async () => {
        if (captureStream) {
            return;
        }
        try {
            const captureStream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);
            setCaptureStream(captureStream);
            startRecorder(captureStream);
        }
        catch (e) {
            const err = `Error: ${e}`;
            toast(err, {
                toastId: 'recording-status',
                type: 'error',
            });
            setHasError(true);
            setCaptureStream(null);
        }
    };
    const stopRecording = () => {
        if (recorder) {
            recorder.stop();
        }
        if (captureStream) {
            captureStream === null || captureStream === void 0 ? void 0 : captureStream.getTracks().forEach((track) => track.stop());
            setCaptureStream(null);
        }
    };
    const startRecorder = (captureStream) => {
        var _a, _b;
        const date = new Date();
        const fileName = `${roomId}_${date.toLocaleString()}`;
        const ctx = new AudioContext();
        const dest = ctx.createMediaStreamDestination();
        if (captureStream.getAudioTracks().length) {
            ctx.createMediaStreamSource(captureStream).connect(dest);
        }
        const localTrack = localParticipant.getTrack(Track.Source.Microphone);
        if ((_a = localTrack === null || localTrack === void 0 ? void 0 : localTrack.audioTrack) === null || _a === void 0 ? void 0 : _a.mediaStream) {
            ctx
                .createMediaStreamSource((_b = localTrack === null || localTrack === void 0 ? void 0 : localTrack.audioTrack) === null || _b === void 0 ? void 0 : _b.mediaStream)
                .connect(dest);
        }
        let mimeType = 'video/webm';
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            mimeType = 'video/mp4';
        }
        const videoTrack = captureStream.getVideoTracks()[0];
        const streams = [videoTrack];
        if (dest.stream.getTracks().length) {
            const mixedTracks = dest.stream.getTracks()[0];
            streams.push(mixedTracks);
        }
        const combineStreams = new MediaStream(streams);
        const recorder = new MediaRecorder(combineStreams, {
            mimeType,
        });
        recorder.onstart = () => {
            setRecordingEvent(RecordingEvent.STARTED_RECORDING);
            setHasError(false);
            broadcastNotification(true);
        };
        recorder.ondataavailable = (e) => {
            recordingData.push(e.data);
        };
        recorder.onstop = () => {
            setRecordingEvent(RecordingEvent.STOPPED_RECORDING);
            setHasError(false);
            const blobData = new Blob(recordingData, { type: mimeType });
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.style = 'display: none';
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            // mostly happen if user close sharing directly
            if (captureStream) {
                captureStream === null || captureStream === void 0 ? void 0 : captureStream.getTracks().forEach((track) => track.stop());
                setCaptureStream(null);
            }
            setRecorder(null);
            recordingData = [];
            broadcastNotification(false);
        };
        recorder.onerror = () => {
            setHasError(true);
            if (captureStream) {
                captureStream === null || captureStream === void 0 ? void 0 : captureStream.getTracks().forEach((track) => track.stop());
                setCaptureStream(null);
            }
            setRecorder(null);
            recordingData = [];
        };
        recorder.start();
        setRecorder(recorder);
    };
    const broadcastNotification = (start = true) => {
        var _a, _b, _c, _d;
        const data = {
            type: DataMsgType.SYSTEM,
            roomSid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
            body: {
                type: DataMsgBodyType.INFO,
                from: {
                    sid: (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.sid,
                    userId: (_b = session.currentUser) === null || _b === void 0 ? void 0 : _b.userId,
                },
            },
        };
        if (start) {
            data.body.msg = t('notifications.local-recording-started', {
                name: (_c = session.currentUser) === null || _c === void 0 ? void 0 : _c.name,
            });
        }
        else {
            data.body.msg = t('notifications.local-recording-ended', {
                name: (_d = session.currentUser) === null || _d === void 0 ? void 0 : _d.name,
            });
        }
        const dataMsg = new DataMessage(data);
        sendWebsocketMessage(dataMsg.toBinary());
    };
    const resetError = () => {
        if (hasError) {
            setHasError(false);
        }
    };
    return {
        TYPE_OF_RECORDING,
        recordingEvent,
        hasError,
        startRecording,
        stopRecording,
        resetError,
    };
};
_react_refresh_temp_1(useLocalRecording, "O8AIFkkBfKPPRxOya4dRP9hwYYU=", false, () => [useTranslation]);
export default useLocalRecording;
